import { SvgIcon, SvgIconProps } from "@mui/material";

export const Horizontal3DotsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M17.502 12.003c0 .275.225.5.5.497.276 0 .5-.225.5-.5s-.224-.5-.5-.5c-.275 0-.5.225-.5.503M11.5 12.003c0 .275.225.5.5.497.275 0 .5-.225.5-.5s-.225-.5-.5-.5-.5.225-.5.503M5.497 12.003c0 .275.225.5.5.497.276 0 .5-.225.5-.5s-.224-.5-.5-.5c-.275 0-.5.225-.5.503"
      />
    </svg>
  </SvgIcon>
);
